<template>
  <div :id="`${pdfNum}_pdf_${pageOrder}`">
    <div class="d-flex justify-end">
      <div class="mx-8 my-4">
        <div class="d-flex justify-end">
          <span class="black--text font-weight-bold" style='font-family:"MS Pゴシック", sans-serif !important; font-size: 11px'>Confidential</span>
        </div>
        <v-img :src="require('@/assets/images/report_header.png')" width="120px" eager></v-img>
      </div>
    </div>
    <div class="ma-10 mt-0" style="height: 930px;">
      <p class="font-weight-bold text-h5">{{naviVisibleList.findIndex(item => item.text === 'ドローン検査詳細（抜粋）')+pdfNum}}.{{getTitle(title)}}</p>
      <div style="overflow: hidden; height: 882px;">
        <div style="position: relative; top: -127px; left: -40px; width: 210mm; height: 297mm;">
          <v-img :src="page" v-if="page" width="100%" height="100%" eager @load="doneLoadingPdfPage"></v-img>
        </div>
      </div>
    </div>
    <div class="mr-8">
      <div class="d-flex align-end justify-end">
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 12px">‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐</span>
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 12px">{{getPageNumber()}}/{{naviVisibleList.length + pdfPageNum + cropImagePageNum + 1}}</span>
      </div>
      <div class="d-flex align-end justify-end">
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 11px">Copyright East Engineering Co., Ltd. all rights reserved</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PdfPage",
  props: ['pdfNum', 'naviVisibleList', 'cropImagePageNum', 'title', 'pageOrder', 'pdfPageNum', 'page', 'pdfId'],
  data() {
    return {
      src: null
    }
  },
  methods: {
    getTitle(text){
      if (text){
        if (text.includes('blank')) return '';
        else return text;
      }
      return '';
    },
    getPageNumber(){
      let num = 0;
      const lastIndex = this.naviVisibleList.findIndex(item => item.text === 'ドローン検査詳細（抜粋）');
      const list = this.naviVisibleList.slice(lastIndex+1, lastIndex+this.pdfNum+1);
      list.forEach(item => {
        num += Number(item.pageAmount)-1;
      })
      return num + this.cropImagePageNum + lastIndex + 1 + this.pageOrder + 1 + this.pdfNum + 1;
    },
    doneLoadingPdfPage(){
      this.$emit('doneLoadingPdfPage', this.pdfId);
    }
  },
}
</script>

<style scoped>

</style>
